import { faRunning } from "@fortawesome/pro-duotone-svg-icons/faRunning";

import { type Breadcrumb } from "@application/types/breadcrumb";

export const DASHBOARD_RUNS_LINK: Breadcrumb = {
  icon: faRunning,
  name: "Runs",
  to: "/dashboard/runs",
};
